import { LogoutOutlined } from "@mui/icons-material";
import { useKeycloak } from "@react-keycloak/web";
import React, { ReactElement } from "react";
import { Link, useNavigate } from "react-router-dom";

import CompanyLogo from "../assets/media/logo.svg";
import ActiveClientSelector from "../components/active-client-selector/active-client-selector";
import { AppContext } from "../context/app-context";
import { useLocalStorage } from "../hooks/use-local-storage";
import { LOCAL_STORAGE_ACTIVE_CLIENT_ID } from "../providers/active-client-provider";
import { UserContext } from "../providers/user-provider";

export default function Header(): ReactElement {
  // const { directus } = useDirectus();
  const { setToken } = React.useContext(AppContext);
  const { me } = React.useContext(UserContext);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { removeItem } = useLocalStorage(LOCAL_STORAGE_ACTIVE_CLIENT_ID);

  const handleLogout = (): void => {
    // await directus?.auth.refreshIfExpired();
    // await directus?.auth.logout();
    removeItem();
    keycloak.logout();
    setToken(null);
    navigate(`/`);
  };

  return (
    <div className="mb-30 flex w-full flex-row justify-between pl-[45px]">
      <div className="flex items-center">
        <div className="pt-5 pb-15 pr-15 border-r border-neutral-400 relative">
          <Link to="/">
            <img className="max-h-full" src={CompanyLogo} alt="Company Logo" />
          </Link>
          <span className="text-[10px] absolute right-16 bottom-5 font-bold text-gray-400">
            METAHUB
          </span>
        </div>
      </div>
      <div className="flex flex-row items-center gap-30">
        {me && <ActiveClientSelector user={me} />}
        <button
          onClick={handleLogout}
          className="flex cursor-pointer flex-row items-center gap-10"
          type="button"
        >
          <p className="text-base uppercase text-companyDarkGrey">Logout</p>
          <LogoutOutlined className="fill-companyDarkGrey" />
        </button>
      </div>
    </div>
  );
}
